var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"publicListWrap"},_vm._l((_vm.list),function(v,i){return _c('li',{key:i,class:_vm.$parent.active == i ? 'activeLi' : '',on:{"click":function($event){return _vm.changeActive(v, i)}}},[_c('p',[_vm._v(_vm._s(v.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }